import { TPriceRespApiDto } from '../api.types'

export const getPairPriceApiRespMock: TPriceRespApiDto = {
    amount_base: 0.00417475,
    amount_quote: 100.0,
    timestamp: 1608703587.861098,
    price: 23953.53015151,
    pair: {
        base: 'BTC',
        quote: 'EUR',
    },
    max_amount_base: 0.93444977,
    max_amount_quote: 20000.0,
    min_amount_base: 0.001,
    min_amount_quote: 32.62,
}
